import { render, staticRenderFns } from "./TTab.vue?vue&type=template&id=6e73e94c&scoped=true&"
import script from "./TTab.vue?vue&type=script&lang=js&"
export * from "./TTab.vue?vue&type=script&lang=js&"
import style0 from "./TTab.vue?vue&type=style&index=0&id=6e73e94c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e73e94c",
  null
  
)

export default component.exports